const TARGET_STEPS = 6;

/** The smallest round step (1, 2 or 5 × 10ⁿ, at least 1) that splits `max` into at most TARGET_STEPS steps. */
const roundStep = max => {
    const raw = Math.max(max / TARGET_STEPS, 1);
    const magnitude = 10 ** Math.floor(Math.log10(raw));
    const step = [1, 2, 5, 10].map(m => m * magnitude).find(s => s >= raw);

    return step;
};

/**
 * The y axis for a line chart whose highest value is `maxValue`: a round step and a max strictly above the highest
 * value, so the line (and its curve) never leaves the chart (SC-QA-145: the old step list ended at 5,000, which
 * capped every chart at 30,000). With no data above 0 the axis shows 0–6.
 */
export const yAxisScale = maxValue => {
    const value = Number.isFinite(maxValue) && maxValue > 0 ? maxValue : 0;
    if (value === 0) return { stepSize: 1, max: TARGET_STEPS };

    const stepSize = roundStep(value);

    return { stepSize, max: stepSize * (Math.floor(value / stepSize) + 1) };
};
